const common = {
  "site.name": "红桃视频网页版",
  "site.slogan": "免费在线观看高清视频",
  "site.description": "红桃视频网页版为您提供海量高清视频在线免费观看体验",

  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索视频...",

  "category.movie": "电影",
  "category.tv": "电视剧",
  "category.variety": "综艺",
  "category.anime": "动漫",
  "category.documentary": "纪录片",
  "category.music": "音乐",
  "category.sports": "体育",
  "category.game": "游戏",
  "category.all": "全部",

  "home.hero.title": "海量高清视频，免费在线观看",
  "home.hero.subtitle": "无需下载安装，打开浏览器即可畅享。PC端、手机端均可流畅播放",
  "home.hero.cta": "开始观看",
  "home.featured": "精选推荐",
  "home.categories": "视频分类",
  "home.latest": "最新更新",
  "home.viewAll": "查看全部",

  "article.watch": "立即观看",
  "article.related": "相关推荐",
  "article.share": "分享",
  "article.views": "次播放",

  "about.title": "关于红桃视频",
  "about.brand": "品牌介绍",
  "about.reputation": "用户口碑",
  "about.contact": "联系我们",

  "footer.rights": "版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.help": "帮助中心",

  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.article": "文章详情",
  "breadcrumb.about": "关于我们",

  "seo.homeTitle": "红桃视频网页版 - 免费在线观看高清视频 | 红桃视频官网",
  "seo.homeDesc": "红桃视频网页版为您提供海量高清视频在线免费观看体验，无需下载安装，打开浏览器即可畅享。支持多终端访问，PC端、手机端均可流畅播放，内容丰富，更新及时。",
  "seo.homeKeys": "红桃视频网页版,红桃视频在线观看,红桃视频PC端,红桃视频免费播放,红桃视频高清,红桃视频网址入口,红桃视频官网网页版",

  "seo.categoryTitle": "视频分类 | 红桃视频网页版",
  "seo.articleTitle": "视频详情 | 红桃视频网页版",
  "seo.aboutTitle": "关于我们 | 红桃视频网页版",
};

export default common;